/* Lunelle FX: block-glitch hover on product cards + soft fade page transitions */
(function () {
  'use strict';
  if (window.Shopify && Shopify.designMode) {
    document.documentElement.classList.remove('lfx-entering');
    return;
  }
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function shuffle(a) {
    for (var i = a.length - 1; i > 0; i--) {
      var j = (Math.random() * (i + 1)) | 0;
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }
  function grid(cols, rows) {
    var t = [];
    for (var r = 0; r < rows; r++) for (var c = 0; c < cols; c++) t.push([c, r]);
    return shuffle(t);
  }
  function cell(c, r, cols, rows, W, H) {
    var x = Math.floor((c * W) / cols), y = Math.floor((r * H) / rows);
    return [x, y, Math.floor(((c + 1) * W) / cols) - x, Math.floor(((r + 1) * H) / rows) - y];
  }

  /* ---------- 1. Hover glitch on product cards ---------- */
  function coverRect(iw, ih, w, h) {
    var s = Math.max(w / iw, h / ih), sw = w / s, sh = h / s;
    return [(iw - sw) / 2, (ih - sh) / 2, sw, sh];
  }

  function setupCard(media) {
    if (media.dataset.lfx) return;
    var imgs = media.querySelectorAll(':scope > img');
    if (imgs.length < 2) return;
    media.dataset.lfx = '1';
    media.classList.add('lfx-media');
    var second = imgs[1];
    var cv = document.createElement('canvas');
    cv.className = 'lfx-canvas';
    media.appendChild(cv);
    var ctx = cv.getContext('2d');
    var raf = 0, showing = false, W, H, cols, rows, src;

    function ready() { return second.complete && second.naturalWidth > 0; }
    function prep() {
      var r = media.getBoundingClientRect();
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      W = Math.max(1, Math.round(r.width * dpr));
      H = Math.max(1, Math.round(r.height * dpr));
      if (cv.width !== W || cv.height !== H) { cv.width = W; cv.height = H; }
      cols = 9;
      rows = Math.max(4, Math.round((cols * H) / W));
      src = coverRect(second.naturalWidth, second.naturalHeight, W, H);
    }
    function drawCell(c, r, glitch) {
      var b = cell(c, r, cols, rows, W, H), k = src[2] / W;
      var shift = glitch ? (Math.random() - 0.5) * b[2] * 1.6 : 0;
      ctx.drawImage(second, src[0] + (b[0] + shift) * k, src[1] + b[1] * k, b[2] * k, b[3] * k, b[0], b[1], b[2], b[3]);
    }
    function clearCell(c, r) {
      var b = cell(c, r, cols, rows, W, H);
      ctx.clearRect(b[0], b[1], b[2], b[3]);
    }
    function full() { ctx.drawImage(second, src[0], src[1], src[2], src[3], 0, 0, W, H); }

    function run(show) {
      cancelAnimationFrame(raf);
      showing = show;
      if (!ready()) {
        if (show) second.addEventListener('load', function () { if (showing) run(true); }, { once: true });
        return;
      }
      prep();
      var order = grid(cols, rows), total = order.length, done = 0, t0 = performance.now(), dur = show ? 360 : 300;
      function step(now) {
        var p = Math.min(1, (now - t0) / dur);
        var target = Math.floor(p * total);
        while (done < target) {
          var t = order[done++];
          if (show) drawCell(t[0], t[1], Math.random() < 0.3);
          else clearCell(t[0], t[1]);
        }
        if (p < 1) raf = requestAnimationFrame(step);
        else if (show) full();
        else ctx.clearRect(0, 0, W, H);
      }
      raf = requestAnimationFrame(step);
    }

    var host = media.closest('.card-wrapper') || media;
    host.addEventListener('mouseenter', function () { run(true); });
    host.addEventListener('mouseleave', function () { run(false); });
    window.addEventListener('resize', function () {
      if (showing && ready()) { prep(); full(); }
    });
  }

  function scanCards(root) {
    (root || document).querySelectorAll('.card__media .media').forEach(setupCard);
  }

  if (canHover && !reduce) {
    document.documentElement.classList.add('lfx-hover');
    scanCards();
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes.length) { scanCards(); break; }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* ---------- 2. Page transition: soft fade to white ---------- */
  var KEY = 'lfx-nav';
  var ov = document.createElement('canvas');
  ov.id = 'lfx-ov';
  document.body.appendChild(ov);
  var octx = ov.getContext('2d');
  var otimer = 0;

  function sizeOv() {
    ov.width = 2;
    ov.height = 2;
    octx.fillStyle = '#ffffff';
    octx.fillRect(0, 0, 2, 2);
  }
  function animateOv(cover, done) {
    clearTimeout(otimer);
    sizeOv();
    var dur = cover ? 350 : 550;
    ov.style.transition = 'none';
    ov.style.opacity = cover ? '0' : '1';
    ov.classList.add('is-active');
    void ov.offsetWidth;
    ov.style.transition = 'opacity ' + dur + 'ms ease';
    ov.style.opacity = cover ? '1' : '0';
    otimer = setTimeout(function () {
      if (!cover) ov.classList.remove('is-active');
      if (done) done();
    }, dur + 20);
  }

  function entering() {
    var html = document.documentElement;
    if (!html.classList.contains('lfx-entering')) return;
    try { sessionStorage.removeItem(KEY); } catch (e) {}
    sizeOv();
    ov.style.transition = 'none';
    ov.style.opacity = '1';
    ov.classList.add('is-active');
    html.classList.remove('lfx-entering');
    requestAnimationFrame(function () { animateOv(false); });
  }

  function shouldHandle(e, a) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return false;
    if (!a || !a.href || a.target === '_blank' || a.hasAttribute('download')) return false;
    if (a.getAttribute('role') === 'button' || a.closest('[data-no-transition]')) return false;
    var raw = a.getAttribute('href') || '';
    if (raw.charAt(0) === '#' || raw.indexOf('javascript:') === 0 || raw.indexOf('mailto:') === 0 || raw.indexOf('tel:') === 0) return false;
    var url;
    try { url = new URL(a.href, location.href); } catch (err) { return false; }
    if (url.origin !== location.origin) return false;
    if (url.pathname === location.pathname && url.search === location.search && url.hash) return false;
    if (/\/(cart\/(add|change|clear)|account\/logout|checkout)/.test(url.pathname)) return false;
    return url;
  }

  if (!reduce) {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a');
      var url = shouldHandle(e, a);
      if (!url) return;
      e.preventDefault();
      try { sessionStorage.setItem(KEY, '1'); } catch (err) {}
      animateOv(true, function () { window.location.href = url.href; });
    });
  }

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      clearTimeout(otimer);
      ov.classList.remove('is-active');
      ov.style.opacity = '0';
      document.documentElement.classList.remove('lfx-entering');
      try { sessionStorage.removeItem(KEY); } catch (err) {}
    }
  });

  entering();
})();